angular.module('workflow.app').filter 'unique', () ->

  return (items, filterOn) ->

    if (filterOn == false)
      return items

    if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items))
      hashCheck = {}
      newItems = []

      extractValueToCompare = (item) ->
        if (angular.isObject(item) && angular.isString(filterOn))
          return item[filterOn]
        else
          return item

      angular.forEach items, (item) ->
        isDuplicate = false

        for newItem in newItems
          if (angular.equals(extractValueToCompare(newItem), extractValueToCompare(item)))
            isDuplicate = true

        if (!isDuplicate)
          newItems.push(item)

      items = newItems

    items
